__turbopack_context__.v({
  "bottom": "Tooltip-module-scss-module__-g_hoa__bottom",
  "bottomSheetBody": "Tooltip-module-scss-module__-g_hoa__bottomSheetBody",
  "closeIcon": "Tooltip-module-scss-module__-g_hoa__closeIcon",
  "contentWrapper": "Tooltip-module-scss-module__-g_hoa__contentWrapper",
  "left": "Tooltip-module-scss-module__-g_hoa__left",
  "right": "Tooltip-module-scss-module__-g_hoa__right",
  "tooltipContainer": "Tooltip-module-scss-module__-g_hoa__tooltipContainer",
  "tooltipWrapper": "Tooltip-module-scss-module__-g_hoa__tooltipWrapper",
  "top": "Tooltip-module-scss-module__-g_hoa__top",
});
